module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "plekan-area"
  }, [(_vm.store.state.languages.length > 1) ? _c('change-language') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "plekan-container",
    class: {
      'plekan-translate-mode': _vm.translateMode
    }
  }, [_c('arena-column', {
    attrs: {
      "isTranslate": false,
      "rows": _vm.rows,
      "editAsHTMLRow": _vm.editAsHTMLRow,
      "language": _vm.currentLanguge
    }
  }), _vm._v(" "), (_vm.store.state.languages.length > 1) ? _c('arena-column', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.translateMode),
      expression: "translateMode"
    }],
    attrs: {
      "isTranslate": true,
      "rows": _vm.rows,
      "editAsHTMLRow": _vm.editAsHTMLRow,
      "language": _vm.translateLanguage
    }
  }) : _vm._e(), _vm._v(" "), _c('modal', {
    staticClass: "edit-modal",
    attrs: {
      "show": _vm.editRow.row ? true : false
    }
  }, [_c('header', {
    slot: "header"
  }, [_c('div', {
    staticClass: "plekan-modal-title"
  }, [_vm._v("Edit As Html")])]), _vm._v(" "), _c('div', {
    staticClass: "plekan-edit-as-html-modal-body",
    slot: "body"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editRow.html),
      expression: "editRow.html"
    }],
    domProps: {
      "value": (_vm.editRow.html)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editRow.html = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('footer', {
    staticClass: "plekan-clearfix",
    slot: "footer"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.saveEditAsHtml($event)
      }
    }
  }, [_vm._v("Save HTML")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "plekan-container"
  }, [_c('div', {
    staticClass: "plekan-footer"
  }, _vm._l((_vm.$plekan_buttons), function(b) {
    return _c('button', {
      class: b.class,
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          b.callback(_vm.returnStoreRows)
        }
      }
    }, [_vm._v("\n        " + _vm._s(b.text) + "\n      ")])
  }))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28e191bb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/arena.vue
// module id = 110
// module chunks = 0